import { PaymentType } from "src/api";
import { usePaymentValidation } from "src/hooks";
import { _t } from "src/utils/translation";

interface UseDepositValidationParams {
  amount: string;
  conversionFlowEnabled: boolean;
  ozowEstimateQuoteError?: string | null;
  totalToReceive?: number;
  paymentFeeError?: string | null;
  paymentFee?: number;
  /** Remaining limit-group headroom (wallet currency); Infinity = no cap. */
  availableLimit?: number;
}

export interface DepositErrors {
  inputErrors: string[];
  paymentFeeErrors: string[];
  paymentValidationErrors: string[];
}

export const useDepositValidation = (params: UseDepositValidationParams) => {
  const {
    amount,
    conversionFlowEnabled,
    ozowEstimateQuoteError,
    totalToReceive,
    paymentFeeError,
    paymentFee,
    availableLimit,
  } = params;

  const numericAmount = Number(amount);

  const { paymentValidationErrors } = usePaymentValidation({
    amount: numericAmount,
    paymentType: PaymentType.Deposit,
    fee: conversionFlowEnabled ? undefined : paymentFee,
    availableLimit,
  });

  const errors: DepositErrors = {
    inputErrors: [
      ...(!amount ? [_t("VALIDATION.AMOUNT_SHOULD_NOT_BE_EMPTY")] : []),
      ...(numericAmount <= 0 ? [_t("VALIDATION.AMOUNT_SHOULD_BE_GREATER_THAN_ZERO")] : []),
    ],
    paymentFeeErrors: conversionFlowEnabled
      ? ozowEstimateQuoteError
        ? [ozowEstimateQuoteError]
        : []
      : paymentFeeError
        ? [_t("VALIDATION.ERROR_ESTIMATING_PAYMENT_FEE")]
        : [],
    paymentValidationErrors: conversionFlowEnabled
      ? [
          ...paymentValidationErrors,
          ...(totalToReceive !== undefined && totalToReceive <= 0
            ? [_t("VALIDATION.AMOUNT_AFTER_FEE_SHOULD_BE_GREATER_THAN_ZERO")]
            : []),
        ]
      : paymentValidationErrors,
  };

  return { errors };
};
